module.exports = __webpack_public_path__ + "img/heating-type-01-label-es.asset.de975bfe.svg";